var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hm-tags-container"},_vm._l((_vm.tags),function(tag){return _c('HMTag',{key:tag.id,ref:("tag-" + (tag.id)),refInFor:true,staticClass:"mb-2 mr-2 smaller",attrs:{"title":tag.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }